import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#F8F5F0] flex items-center justify-center p-8">
          <div className="bg-white p-12 rounded-lg border border-[#D1CCC0] shadow-xl max-w-md text-center">
            <div className="text-6xl mb-6">🐟</div>
            <h2 className="font-serif text-2xl font-black italic text-[#3B4D3C] mb-4">
              Noe gikk galt
            </h2>
            <p className="text-[#3B4D3C]/70 mb-8">
              FiskDa støtte på et problem. Prøv å laste siden på nytt.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="bg-[#3B4D3C] text-white px-8 py-3 rounded font-serif italic hover:bg-[#2D3A2D] transition-colors"
            >
              Last på nytt
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;